import { render, staticRenderFns } from "./Add_client.vue?vue&type=template&id=414ca1a3"
import script from "./Add_client.vue?vue&type=script&lang=js"
export * from "./Add_client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports